import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useQueryParam, StringParam } from 'use-query-params';
import Environments, {
  TARGET_ID,
  TARGET_TYPE,
} from 'components/pages/request/requestPartials/createRequestFieldsPartials/Environments';
import CustomerEnvironment from 'components/pages/request/requestPartials/createRequestFieldsPartials/CustomerEnivronment';
import EosServiceEnvironment from 'components/pages/request/requestPartials/createRequestFieldsPartials/EosServiceEnvironment';
import GlobalServiceEnvironment from 'components/pages/request/requestPartials/createRequestFieldsPartials/GlobalServiceEnvironment';
import RequestDetails from 'components/pages/request/requestPartials/createRequestFieldsPartials/RequestDetails';
import AccessType from 'components/pages/request/requestPartials/createRequestFieldsPartials/AccessType';
import { RequestTargetType } from 'gql/Request';
import RequestAccessSlice from 'components/app/store/requestAccess/RequestAccessSlice';
import AWSAccount from 'components/pages/request/requestPartials/createRequestFieldsPartials/AWSAccount';
import MsEntraIDEnvironment from 'components/pages/request/requestPartials/createRequestFieldsPartials/MsEntraIDEnvironment';
import KubernetesClusterEnvironment from './createRequestFieldsPartials/KubernetesClusterEnvironment';
import RequestPagingInfo from './createRequestFieldsPartials/RequestPagingData';

const CreateRequestFields = (): React.ReactElement => {
  const dispatch = useDispatch();
  const [targetTypeQuery] = useQueryParam(TARGET_TYPE, StringParam);
  const [targetIdQuery] = useQueryParam(TARGET_ID, StringParam);

  // Initial Request to get all accessTypes available to this user
  useEffect(() => {
    dispatch(RequestAccessSlice.actions.fetchRequestAccess());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * NOTE:
   * Please make component specific queries inside the individual components.
   * This component acts as an aggregator and a switch between loaded sub-components.
   * It should have minimal logic!
   */

  return (
    <>
      <Environments />
      {targetTypeQuery === RequestTargetType.CustomerEnvironment && <CustomerEnvironment />}
      {targetTypeQuery === RequestTargetType.EosService && <EosServiceEnvironment />}
      {targetTypeQuery === RequestTargetType.GlobalService && <GlobalServiceEnvironment />}
      {targetTypeQuery === RequestTargetType.AWSAccount && <AWSAccount />}
      {targetTypeQuery === RequestTargetType.KubernetesCluster && <KubernetesClusterEnvironment />}
      {targetTypeQuery === RequestTargetType.MsEntraID && <MsEntraIDEnvironment />}
      {targetTypeQuery && targetIdQuery && <AccessType />}
      <RequestDetails />
      <RequestPagingInfo />
    </>
  );
};

export default CreateRequestFields;
